import { Outlet } from "react-router-dom";
import { NavLinks } from "./nav-links";
import { UserMenu } from "./user-menu";
import { Logo } from "./logo";
import { useAuth } from "@/auth/useAuth";
import { getTokenUserId } from "@/auth/tokenUtils";
import { HolyModeProvider } from "@/preferences/holy-mode";

export function AppShell() {
  const { token } = useAuth();
  const userId = getTokenUserId(token);
  return (
    <HolyModeProvider userId={userId}>
      <div className="bible-app-shell bg-background min-h-screen">
        <header className="bible-app-header border-border bg-surface sticky top-0 z-30 flex h-14 items-center gap-6 border-b px-4 sm:px-6">
          <Logo size={32} withWordmark />
          <NavLinks />
          <div className="bible-app-actions ml-auto">
            <UserMenu />
          </div>
        </header>
        <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
          <CathedralGlass />
          <Outlet />
        </main>
      </div>
    </HolyModeProvider>
  );
}

function CathedralGlass() {
  return (
    <div className="cathedral-glass" data-stained-glass="cathedral" aria-hidden="true">
      <LancetWindow subject="dove" />
      <svg className="cathedral-glass-rose" viewBox="0 0 160 160" focusable="false">
        <circle cx="80" cy="80" r="76" fill="#641d2b" stroke="#e8c875" strokeWidth="4" />
        <path d="M80 8 96 54 138 22 106 64 152 80 106 96 138 138 96 106 80 152 64 106 22 138 54 96 8 80 54 64 22 22 64 54Z" fill="#1c7480" stroke="#f0d58b" strokeWidth="3" />
        <circle cx="80" cy="80" r="48" fill="#a82d46" stroke="#f0d58b" strokeWidth="3" />
        <path d="M80 33 91 67 126 56 103 83 126 108 91 97 80 131 69 97 34 108 57 83 34 56 69 67Z" fill="#d7a531" stroke="#fff0b9" strokeWidth="3" />
        <circle cx="80" cy="80" r="15" fill="#203f78" stroke="#fff0b9" strokeWidth="3" />
        <path d="M80 5v150M5 80h150M27 27l106 106m0-106L27 133" fill="none" stroke="#f5d98a" strokeWidth="2" />
        <circle cx="80" cy="80" r="7" fill="#fff0b9" />
      </svg>
      <LancetWindow subject="cross" />
    </div>
  );
}

function LancetWindow({ subject }: { subject: "dove" | "cross" }) {
  return (
    <svg className="cathedral-glass-lancet" viewBox="0 0 120 160" focusable="false">
      <path d="M5 155V67L60 5l55 62v88Z" fill="#321d36" stroke="#e8c875" strokeWidth="4" />
      <path d="M12 153V69L60 14v139Z" fill="#174b75" />
      <path d="M60 14v139h48V69Z" fill="#8e2348" />
      <path d="M12 69h96M60 14v139M13 111h94" fill="none" stroke="#f1d48a" strokeWidth="3" />
      <path d="M13 69 60 14l47 55" fill="none" stroke="#fff0b9" strokeWidth="2" />
      {subject === "dove" ? (
        <path d="M60 78c-6-9-17-12-29-8 8 5 12 10 13 16-9-4-17-3-25 2 13 1 23 7 29 15l12-7 12 7c6-8 16-14 29-15-8-5-16-6-25-2 1-6 5-11 13-16-12-4-23-1-29 8Z" fill="#f1d48a" stroke="#fff3c8" strokeWidth="2" strokeLinejoin="round" />
      ) : (
        <>
          <path d="M53 74h14v19h18v14H67v32H53v-32H35V93h18Z" fill="#f1d48a" stroke="#fff3c8" strokeWidth="2" />
          <path d="M28 141h23v9H28Zm41 0h23v9H69Z" fill="#2da4a0" stroke="#fff3c8" strokeWidth="2" />
        </>
      )}
      <path d="M18 153 60 111l42 42" fill="none" stroke="#e8c875" strokeWidth="2" />
    </svg>
  );
}
